import {
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  Companion_getInstance1s7l2zevnsf8e as Companion_getInstance,
  Badge28jlxgdx0n9um as Badge,
} from '../Badge.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Adapter1t72m9xaryzfb as Adapter } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapter.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var Badge_ResponseAdapterClass;
function Badge_ResponseAdapter() {
  if (Badge_ResponseAdapterClass === VOID) {
    class $ {
      t3x(reader, customScalarAdapters) {
        var rawValue = ensureNotNull(reader.t3y());
        return Companion_getInstance().w6o(rawValue);
      }
      u6l(writer, customScalarAdapters, value) {
        writer.v3y(value.c6p_1);
      }
      u3x(writer, customScalarAdapters, value) {
        return this.u6l(writer, customScalarAdapters, value instanceof Badge() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'Badge_ResponseAdapter', VOID, VOID, [Adapter()]);
    Badge_ResponseAdapterClass = $;
  }
  return Badge_ResponseAdapterClass;
}
var Badge_ResponseAdapter_instance;
function Badge_ResponseAdapter_getInstance() {
  return Badge_ResponseAdapter_instance;
}
//region block: init
Badge_ResponseAdapter_instance = new (Badge_ResponseAdapter())();
//endregion
//region block: exports
export {
  Badge_ResponseAdapter_instance as Badge_ResponseAdapter_instance1qq3nwu3zphmj,
};
//endregion

//# sourceMappingURL=Badge_ResponseAdapter.mjs.map
